const strings = {
  START_TIME: 'Starttid',
  END_TIME: 'Sluttid',
  AVAILABILITY: 'Tillgänglighet',
  PASSWORD: 'Lösenord',
  JANITOR: 'Vaktmästare',
  ADMIN: 'Administratör',
  CANCEL: 'Avbryt',
  DONE: 'Klar'
}

export default strings



// WEBPACK FOOTER //
// ./src/components/common/TimeModal/strings.js